<template>
    <div class="page-wrapper margin-left-sm flex flex-direction">
        <div class="flex align-center justify-between bg-white radius-lg padding margin-bottom-sm" v-if="count">
            <div class="count flex align-center justify-between bg-blue radius">
                <div class="text-xl text-white">项目总数/个</div>
                <div class="number text-white text-bold">{{ count.total_num }}</div>
            </div>
            <div class="count flex  align-center justify-between bg-blue light radius">
                <div class="text-xl text-white">已结项数/个</div>
                <div class="number text-white text-bold">{{ count.finish_num }}</div>
            </div>
            <div class="count flex  align-center justify-between bg-yellow light  radius">
                <div class="text-xl text-white">在执行数/个</div>
                <div class="number text-white text-bold">{{ count.ongoing_num }}</div>
            </div>
            <div class="count flex  align-center justify-between bg-red radius">
                <div class="text-xl text-white">委托单位数/个</div>
                <div class="number text-white text-bold">{{ count.weituo_num }}</div>
            </div>
            <div class="count flex  align-center justify-between bg-green radius">
                <div class="text-xl text-white">成果汇总数/个</div>
                <div class="number text-white text-bold">{{ count.result_num }}</div>
            </div>
        </div>
        <div class="bg-white radius-lg padding flex-sub">
            <div class="search-container min flex align-center">
                <div class="flex align-center">
                    <el-autocomplete class="input" v-model="client" placeholder="请输入委托单位"
                                     :fetch-suggestions="queryClientsSearch" value-key="company_name"
                                     @select="handleClientsSelect"></el-autocomplete>
                    <el-autocomplete class="input margin-left-xs" v-model="undertaker" placeholder="请输入承办单位"
                                     :fetch-suggestions="queryUndertakerSearch" value-key="company_name"
                                     @select="handleUndertakerSelect"></el-autocomplete>
                    <el-select class="margin-left-xs" v-model="p_mid" filterable clearable placeholder="请选择负责人">
                        <el-option
                            v-for="item in members"
                            :key="item.mid"
                            :label="item.name"
                            :value="item.mid">
                        </el-option>
                    </el-select>
                    <el-date-picker
                        class="margin-left-xs"
                        v-model="sort_date"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="daterange">
                    </el-date-picker>
                    <el-select class="margin-left-xs" v-model="status" clearable placeholder="项目进度">
                        <el-option
                            v-for="item in project_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input class="margin-left-xs" v-model="keyword" placeholder="请输入项目名称"></el-input>
                    <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
                </div>
                <div class="flex align-center">
                    <router-link class="margin-left-xs" to="/web/staff/project/remind">
                        <el-button class="btn min bg-ghost radius"><i class="el-icon-message-solid margin-right-xs"></i>提醒
                        </el-button>
                    </router-link>
                    <router-link class="margin-left-xs" to="/web/staff/project/add/0/0">
                        <el-button class="btn smid bg-orange radius" type="warning">
                            <i class="el-icon-plus margin-right-xs"></i>创建项目
                        </el-button>
                    </router-link>
                </div>
            </div>
            <div class="page-list flex flex-direction margin-top-sm">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    border
                    header-row-class-name="table-header"
                    @sort-change="sortChange"
                    style="width: 100%">
                    <!--                    <el-table-column label="年度" prop="create_time" width="80">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <div class="table-item">-->
                    <!--                                {{ scope.row.create_time | year }}-->
                    <!--                            </div>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column label="项目名称" prop="p_name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.p_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="委托单位" prop="client">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.client || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="承办单位" prop="undertaker">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.undertaker || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="负责人" prop="p_mid" width="120">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.fuzeren_name || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目起始时间" prop="start_time" width="150" sortable="custom">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.start_time || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="计划结束时间" prop="end_time" width="150" sortable="custom">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.end_time || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目进度" prop="status" width="279" sortable="custom">
                        <template slot-scope="scope">
                            <div class="table-item">
                                <div v-if="scope.row.check_status === 0">
                                    <div class="flex flex-direction" v-if="scope.row.status === 2">
                                        <div class="flex align-center">
                                            <div class="flex-shrink text-black text-xs">执行进度</div>
                                            <el-progress class="flex-sub margin-left-xs flex align-center" :stroke-width="10" :color="customColors" :percentage="scope.row.taskLv"></el-progress>
                                        </div>
                                        <div class="flex align-center">
                                            <div class="flex-shrink text-black text-xs">时间进度</div>
                                            <el-progress class="flex-sub margin-left-xs flex align-center" :stroke-width="10" :percentage="scope.row.timeLv"></el-progress>
                                        </div>
                                    </div>
                                    <div :class="scope.row.status | pstatus_color" v-else>{{ scope.row.status | pstatus
                                        }}
                                    </div>
                                </div>
                                <div v-else>{{ scope.row.check_status | cstatus }}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" prop="name" width="350">
                        <template slot-scope="scope">
                            <div class="table-operate text-center">
                                <el-button class="radius blue" type="primary" size="small" @click="toPage(`/web/staff/project/add/${scope.row.id}/0`)">
                                    项目信息
                                </el-button>
                                <el-button class="radius green" :class="{disabled:!scope.row.is_operation}" type="primary" size="small" @click="toPage(`/web/staff/project/report/${scope.row.id}/${scope.row.p_name}`)" :disabled="!scope.row.is_operation">
                                    项目汇报
                                </el-button>
                                <!--                            <el-button class="radius" type="primary" size="small" @click="toPage(`/web/staff/task/list/${scope.row.id}/${scope.row.p_name}`)" :disabled="!scope.row.is_operation">任务分配</el-button>-->
                                <!--                            <el-button class="radius" type="primary" size="small" @click="toPage(`/web/staff/task/assignment/${scope.row.id}/${scope.row.p_name}`)" :disabled="!scope.row.is_operation">权重赋分</el-button>-->
                                <el-button class="radius yellow" type="primary" size="small" @click="toPage(`/web/staff/project/post/${scope.row.id}`)">
                                    项目结项
                                </el-button>
                                <el-button class="radius red" type="primary" size="small" @click="delProject(scope.row)" v-if="user.mrole === 1">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next"
                    @current-change="init">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

import {delProject, getAllMember, getCompanyList, getProjectList, getProjectTotal} from "@/api";
import {confirm, filterDate, TOAST, toast, zhDate} from "@/utils/utils";
import {customColors, project_status} from "@/utils/const";

export default {
    name: "project-list",
    components: {},
    data() {
        return {
            customColors: customColors,
            keyword: '',
            client: '',
            undertaker: '',
            p_mid: '',
            sort: '',//1倒叙 2正序 '' 默认
            start_sort: '',//1倒叙 2正序 '' 默认
            status_sort: '',//1倒叙 2正序 '' 默认
            project_status: project_status,//项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            status: '',//项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            sort_date: [],
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            clients: [],
            undertakers: [],
            members: [],
            count: ''
        }
    },
    created() {
        this.$emit('setIndex', [1,0], '全部项目', false)
        this.getClassify()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getClassify() {
            let _data = await getAllMember()
            this.members = _data.data
            _data = await getCompanyList(1, '', 1, 10000)
            this.clients = _data.data.data
            _data = await getCompanyList(2, '', 1, 10000)
            this.undertakers = _data.data.data
            _data = await getProjectTotal()
            this.count = _data.data
        },
        async init() {
            this.loading = true
            let _data = await getProjectList(this.keyword, this.client, this.undertaker, this.p_mid, this.sort,
                this.start_sort, this.status_sort, this.status, this.sort_date.length ? this.sort_date[0] : '',
                this.sort_date.length ? this.sort_date[1] : '', this.page, this.limit)
            this.loading = false
            _data.data.data.map(item => {
                item.end_time = filterDate(item.end_time)
            })
            this.lists = _data.data.data
            this.total = _data.data.total
        },
        sortChange(e) {
            switch (e.prop) {
                case 'end_time':
                    this.setSortValue('sort', e.order)
                    break
                case 'start_time':
                    this.setSortValue('start_sort', e.order)
                    break
                case 'status':
                    this.setSortValue('status_sort', e.order)
                    break
            }
            this.search()
        },
        setSortValue(key, order) {
            switch (order) {
                case 'descending':
                    this[key] = 1
                    break
                case 'ascending':
                    this[key] = 2
                    break
                default:
                    this[key] = ''
                    break
            }
        },
        search() {
            this.page = 1
            this.init()
        },
        toPage(path) {
            this.$router.push(path)
        },
        delProject(data) {
            confirm(`删除项目`, `你确定删除<b>${data.p_name}</b>项目吗？`, () => {
                this.delItem(data.id)
            }, '确认', true)
        },
        async delItem(id) {
            let _data = await delProject(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        queryClientsSearch(queryString, cb) {
            let restaurants = this.clients;
            let results = queryString ? restaurants.filter(this.createClientsFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createClientsFilter(queryString) {
            return (restaurant) => {
                return (restaurant.company_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleClientsSelect(item) {
            this.client = item.company_name
        },
        queryUndertakerSearch(queryString, cb) {
            let restaurants = this.undertakers
            let results = queryString ? restaurants.filter(this.createUndertakerFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createUndertakerFilter(queryString) {
            return (restaurant) => {
                return (restaurant.company_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleUndertakerSelect(item) {
            this.undertaker = item.company_name
        }
    },
    filters: {
        year(date) {
            return zhDate(date, 4)
        },
        pstatus(status) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            switch (Number(status)) {
                case 0 :
                    return '未提交审核'
                case 1 :
                    return '审核中'
                case 3 :
                    return '审核未通过'
            }
        },
        pstatus_color(status) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            switch (Number(status)) {
                case 0 :
                    return 'text-black'
                case 1 :
                    return 'text-orange'
                case 3 :
                    return 'text-red'
            }
        },
        cstatus(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 0 :
                    return '未结项'
                case 1 :
                    return '正常结项'
                case 2 :
                    return '非正常结项'
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .count {
        flex: 1;
        height: 110px;
        padding: 0 20px;

        .number {
            font-size: 36px;
        }
    }

    .count + .count {
        margin-left: 29px;
    }

    .table-operate {
        .blue {
            background: #5576a0;
            border: none;

            &.disabled {
                background: #5576a033;
            }
        }

        .green {
            background: #4f9f8b;
            border: none;

            &.disabled {
                background: #4f9f8b33;
            }
        }

        .yellow {
            background: #b08e57;
            border: none;

            &.disabled {
                background: #b08e5733;
            }
        }

        .red {
            background: #f43f3b;
            border: none;

            &.disabled {
                background: #f43f3b33;
            }
        }
    }
}
</style>
